export var DUTCHIEPAY = 'dutchiePay';

// ERRORS
export var dutchiePayErrorCodes = {
  S002: 'S002',
  B104: 'B104',
  B105: 'B105'
};
export var getDutchiePayError = function getDutchiePayError(code) {
  if (!code) {
    return 'We were unable to authorize this payment through Pay by Bank.';
  }
  // the **[text]** will be read by React-markup and make the text bold
  var errorMessage = "Pay by Bank is unavailable. Please use a different method of payment. **".concat(code, ".**");
  if (code === dutchiePayErrorCodes.B104) {
    errorMessage = "Your bank account has insufficient funds to complete this transaction. Please either use a different method of payment or add funds to your bank account and try again. **".concat(code, ".**");
  }
  if (code === dutchiePayErrorCodes.B105) {
    errorMessage = "Your bank account is unlinked. **".concat(code, ".**");
  }
  return errorMessage;
};
export var StatusTypes = {
  statusAcceptTerms: 'STATUS_ACCEPT_TERMS',
  statusAccountDisconnected: 'STATUS_ACCOUNT_DISCONNECTED',
  statusAccountPending: 'STATUS_ACCOUNT_PENDING',
  statusAggregatorError: 'STATUS_AGGREGATOR_ERROR',
  statusEnrolled: 'STATUS_ENROLLED',
  statusNoAccount: 'STATUS_NO_ACCOUNT',
  statusUnenrolled: 'STATUS_UNENROLLED',
  statusUnspecified: 'STATUS_UNSPECIFIED'
};